module.exports = __webpack_public_path__ + "img/gch.5b236b41.png";